import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../../../molecules";
import { MODAL_SIZE } from "../../AppModals/modals.constants";
import { actions as modalActions } from "../../Modal/modal.reducers";
import { checkIcon, midLineEllipsisMenuIcon } from "../../../../assets/icons";
import {
  selectSelectedDataModel,
  updateDataModel,
} from "../../../../pages/DataModels";

const { setSelectedModal } = modalActions;
const { MD } = MODAL_SIZE;

const LandingModal = () => {
  const dispatch = useDispatch();
  const dataModel = useSelector(selectSelectedDataModel);
  const [selectedDataModel, setSelectedDataModel] = useState();
  const [hasCollections, setHasCollections] = useState(false);
  const [hasEndpoints, setHasEndpoints] = useState(false);

  useEffect(() => {
    setSelectedDataModel(dataModel);
    if (selectedDataModel) {
      setHasCollections(!!selectedDataModel.collections.length);
      setHasEndpoints(!!selectedDataModel.endpoints.length);
    }
  }, [selectedDataModel, dataModel]);

  const handleClose = useCallback(() => {
    dispatch(setSelectedModal(null));
  }, [dispatch]);

  const footer = (
    <div className="p-6 border-t border-gray-700 text-right">
      <button
        className="btn btn-primary text-white"
        type="submit"
        onClick={handleClose}
      >
        Keep Going!
      </button>
    </div>
  );

  const handleOnClick = () => {
    const updatedDataModel = {
      ...selectedDataModel,
      showSetupModal: !selectedDataModel?.showSetupModal,
    };

    delete updatedDataModel.collections;
    delete updatedDataModel.backgroundTasks;
    delete updatedDataModel.trackDatabaseSetup;
    delete updatedDataModel.endpoints;
    delete updatedDataModel.endpoints;
    delete updatedDataModel.services;
    delete updatedDataModel.applications;

    dispatch(
      updateDataModel({
        id: selectedDataModel.id,
        dataModel: {
          dataModel: selectedDataModel,
          changeSet: updatedDataModel,
        },
      })
    );
  };

  return (
    <Modal title="Welcome" handleClose={handleClose} size={MD} footer={footer}>
      <div className="text-sm text-white p-6">
        <div className="mb-2">
          Your database and auto-generated API is nearly-ready for primetime!
          Complete the following and start building the next earth-shattering
          application in minutes 💪
        </div>
        <div className="flex bg-gray-900 border-solid rounded-lg mt-2 p-3 w-full">
          <div className="align-top">
            {hasCollections ? (
              <img src={checkIcon} alt="checkIcon" className="w-12 sm:w-7" />
            ) : (
              <img
                className="w-12 sm:w-7"
                src={midLineEllipsisMenuIcon}
                alt="midLineEllipsisMenuIcon"
              />
            )}
          </div>
          <div className="ml-3">
            <div className="font-medium text-gray-50">Create a Collection</div>
            <div className="text-gray-300">
              Collections are database tables where you can model your new
              database.
            </div>
          </div>
        </div>
        <div className="flex bg-gray-900 border-solid rounded-lg mt-2 p-3 w-full">
          <div className="align-top">
            {hasEndpoints ? (
              <img src={checkIcon} alt="checkIcon" className="w-20 sm:w-11" />
            ) : (
              <img
                className="w-20 sm:w-12"
                src={midLineEllipsisMenuIcon}
                alt="mid-line-ellipsis-menu-icon"
              />
            )}
          </div>
          <div className="ml-3">
            <div className="font-medium text-gray-50">View Your Endpoints</div>
            <div className="text-gray-300">
              Endpoints allow you to create real-time events. When you create a
              collection, we&apos;ll automatically generate the endpoint for
              you.
            </div>
          </div>
        </div>
        <div className="form-check flex items-center mt-2 gap-x-3">
          <input
            type="checkbox"
            value={!selectedDataModel?.showSetupModel}
            className="text-indigo-600 !rounded focus:ring-0 focus:outline-indigo-300 cursor-pointer"
            onChange={() => {
              handleOnClick();
            }}
          />
          <div className="form-check-label inline-block text-white">
            Don't show it again
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LandingModal;
